

import Vue from 'vue'
import Component from "vue-class-component";

import {Prop, Watch} from "vue-property-decorator";
import {IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
import SpImageInputLayout from "@/components/serviceProvider/v2/layouts/V2SpFormCardLayout.vue";
import V2ImageUploader from "@/components/serviceProvider/v2/SpImageInput/components/V2ImageUploader.vue";

@Component({
  components: {V2ImageUploader, SpImageInputLayout}
})
export default class V2SPImageInput extends Vue {
  @Prop()
  public title!: string;
  @Prop()
  public subTitle!: string;
  @Prop()
  public src!: string;
  @Prop()
  public canEdit!: boolean;
  @Prop(  { default: false })
  public disabled!: boolean;
  @Prop()
  public alert!: string;

  @Prop()
  public isEdit!: boolean;

  @Prop({ default: false })
  public isFullWidth!: boolean;

  public onUpload = (fileToUpload: string) => {
    this.$emit('onUpload', fileToUpload);
  }
}

